import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vevo-wrapper" }
const _hoisted_2 = { class: "vevo-topbar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "vevo-child-selector"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = { class: "vevo-intro" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "vevo-list-container" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-center pa-6"
}
const _hoisted_12 = {
  key: 1,
  class: "vevo-empty"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "vevo-card-icon-wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "vevo-new-badge"
}
const _hoisted_17 = { class: "vevo-card-text" }
const _hoisted_18 = { class: "vevo-card-date" }
const _hoisted_19 = { class: "vevo-card-title" }
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        icon: "",
        variant: "text",
        size: "small",
        class: "vevo-back-btn",
        onClick: _ctx.goBack,
        ripple: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.chevronLeftIcon,
            alt: "back",
            class: "vevo-back-icon"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", {
        class: "vevo-topbar-title",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChildSelector && _ctx.toggleChildSelector(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.selectedChildName || 'レポート'), 1)
      ]),
      _createElementVNode("div", {
        class: "vevo-topbar-right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleChildSelector && _ctx.toggleChildSelector(...args)))
      }, [
        (_ctx.children.length > 1)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              size: "18",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" mdi-arrow-down-drop-circle-outline ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer)
      ])
    ]),
    (_ctx.showChildSelector && _ctx.children.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.childId,
              class: _normalizeClass(["vevo-child-row", { active: c.childId === _ctx.selectedChildId }]),
              onClick: ($event: any) => (_ctx.selectChild(c.childId))
            }, [
              _createElementVNode("img", {
                class: "vevo-child-avatar",
                src: c.imageUrl || _ctx.defaultChildIcon
              }, null, 8, _hoisted_6),
              _createElementVNode("span", _hoisted_7, _toDisplayString(c.lastName) + " " + _toDisplayString(c.firstName), 1)
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: _ctx.mascotPeekImg,
        alt: "VEVO",
        class: "vevo-mascot"
      }, null, 8, _hoisted_9),
      _createElementVNode("div", {
        class: "vevo-bubble",
        style: _normalizeStyle({
          '--bubble-img': `url(${_ctx.speechBubbleImg})`,
          '--bubble-img-full': `url(${_ctx.speechBubbleFullImg})`
        })
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "vevo-bubble-title" }, "保護者のみなさま", -1),
        _createElementVNode("div", { class: "vevo-bubble-body" }, [
          _createTextVNode(" こちらでは成長のようすとして"),
          _createElementVNode("br", { class: "vevo-br" }),
          _createTextVNode(" お子さまの日々の姿を"),
          _createElementVNode("br", { class: "vevo-br" }),
          _createTextVNode(" 3ヶ月に一度お届けします！ ")
        ], -1)
      ]))], 4)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "vevo-list-title" }, "レポート一覧", -1)),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]))
        : (_ctx.reports.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" まだレポートが届いていません。", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" 次のクォーターをお楽しみに！ ", -1)
            ]))]))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (r) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${r.childId}-${r.businessYear}-${r.quarter}`,
          class: "vevo-card",
          onClick: ($event: any) => (_ctx.openDetail(r))
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.isUnread(r) ? _ctx.envelopeIconUnread : _ctx.envelopeIconRead,
              alt: "",
              class: _normalizeClass(["vevo-card-icon", _ctx.isUnread(r) ? 'vevo-icon-unread' : 'vevo-icon-read'])
            }, null, 10, _hoisted_15),
            (_ctx.isUnread(r))
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "NEW"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatPublishedAt(r.publishedAt)) + " 公開", 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(r.title), 1)
          ]),
          _createElementVNode("img", {
            src: _ctx.arrowPlayIcon,
            alt: "",
            class: "vevo-card-arrow"
          }, null, 8, _hoisted_20)
        ], 8, _hoisted_13))
      }), 128))
    ])
  ]))
}